import { getArrowDownIcon, getArrowUpIcon } from '../visual-elements/application-menu/icons';
import { getApplicationMenuLogoByApplicationType, getMenuHeaderLi } from './menu-components';
// {
//     "data": {
//       "applicationTypes": {
//         "nodes": [
//           {
//             "applicationType": "EXPERIENCE_PROGRAMS",
//             "applications": [
//               {
//                 "id": "b62d1ce9-2a6b-419e-b380-27dd26c9a183",
//                 "name": "MOBILE"
//               },
//               {
//                 "id": "c2097ac5-1d74-31e3-92c8-e8643d2e41da",
//                 "name": "WEB"
//               }
//             ],
//             "name": "EXPERIENCE_PROGRAMS"
//           }
//         ],
//         "pageInfo": {
//           "endCursor": null,
//           "hasNextPage": false
//         },
//         "totalCount": 1
//       },
//       "defaultApplicationType": {
//         "applicationType": "EXPERIENCE_PROGRAMS",
//         "applications": [
//           {
//             "id": "b62d1ce9-2a6b-419e-b380-27dd26c9a183",
//             "name": "MOBILE"
//           },
//           {
//             "id": "c2097ac5-1d74-31e3-92c8-e8643d2e41da",
//             "name": "WEB"
//           }
//         ],
//         "name": "EXPERIENCE_PROGRAMS"
//       }
//     },
//     "errors": null,
//     "_links": null,
//     "_allowed": [
//       "POST",
//       "GET"
//     ]
//   }
// PLACEHOLDER - TODO build real util that resolves actual links
const getApplicationLink = (id) => `mock-link/${id}`;
const sanitizeToIdString = (str) => str.replace(/[^a-zA-Z0-9_:-]/g, '');
const convertNodesToGroups = (nodes) => nodes.map((node) => ({
    groupName: node.name,
    groupType: node.applicationType,
    links: node.applications.map((app) => ({
        name: app.name,
        url: getApplicationLink(app.id)
    }))
}));
const processExpandableMenuItems = (linkGroup) => {
    const idString = sanitizeToIdString(linkGroup.groupName);
    const EXPAND_BUTTON_ID = `mas-expandable-static::${idString}`;
    const EXPANDABLE_CONTENT_ID = `mas-section-expandable-static::${idString}`;
    const outerLi = document.createElement('li');
    outerLi.dataset.testid = `mas-AppMenuListExpandableItem::${idString}`;
    outerLi.dataset.testName = 'mas-AppSwitcherMenuButton';
    outerLi.classList.add('mas-app-menu-list-item');
    const appIcon = getApplicationMenuLogoByApplicationType(linkGroup.groupType);
    if (appIcon) {
        const appIconWrapper = document.createElement('div');
        appIconWrapper.classList.add('mas-application-type-logo-wrap');
        appIconWrapper.innerHTML = appIcon;
        outerLi.appendChild(appIconWrapper);
    }
    const expandButton = document.createElement('button');
    // button wrapper for toggling expanded applications list items
    expandButton.setAttribute('id', EXPAND_BUTTON_ID);
    expandButton.setAttribute('type', 'button');
    expandButton.dataset.masOpenState = 'false';
    expandButton.classList.add('mas-application-type-list-item-button');
    // title for applicationType expand button
    const titleSpan = document.createElement('span');
    titleSpan.classList.add('mas-application-type-name');
    titleSpan.textContent = linkGroup.groupName;
    expandButton.appendChild(titleSpan);
    // arrow status indicator icon for expanded state
    const triggerWrap = document.createElement('div');
    triggerWrap.classList.add('mas-expandable-application-trigger');
    const upIcon = getArrowUpIcon();
    const downIcon = getArrowDownIcon(); // show in closed state
    triggerWrap.innerHTML = downIcon;
    // expanded applications list item content
    const groupLiWrapper = document.createElement('li');
    groupLiWrapper.setAttribute('aria-hidden', 'true');
    groupLiWrapper.setAttribute('id', EXPANDABLE_CONTENT_ID);
    groupLiWrapper.setAttribute('aria-labeledby', EXPAND_BUTTON_ID);
    groupLiWrapper.classList.add('mas-app-menu-list-expandable-items-li');
    groupLiWrapper.classList.add('mas-hidden');
    const appsUl = document.createElement('ul');
    appsUl.dataset.testid = 'mas-AppMenuList';
    linkGroup.links &&
        linkGroup.links.forEach(({ name, url }) => {
            const appLi = document.createElement('li');
            appLi.dataset.testid = 'mas-AppMenuListItem';
            appLi.dataset.title = name;
            appLi.classList.add('mas-app-menu-application-item');
            const appAnchor = document.createElement('a');
            appAnchor.classList.add('mas-application-link-anchor');
            appAnchor.setAttribute('href', url);
            appAnchor.textContent = name;
            appLi.appendChild(appAnchor);
            appsUl.appendChild(appLi);
        });
    groupLiWrapper.appendChild(appsUl);
    const expandToggleHandler = () => {
        const wasOpen = expandButton.getAttribute('data-mas-open-state') === 'true';
        triggerWrap.innerHTML = wasOpen ? downIcon : upIcon;
        // show/hide applications UL expanded menu
        groupLiWrapper.setAttribute('aria-hidden', wasOpen ? 'true' : 'false');
        wasOpen ? groupLiWrapper.classList.add('mas-hidden') : groupLiWrapper.classList.remove('mas-hidden');
        // update state open data-attr
        expandButton.dataset.masOpenState = wasOpen ? 'false' : 'true';
    };
    expandButton.appendChild(triggerWrap);
    const expandToggleKeyupHandler = (e) => {
        if (e.code !== 'Enter') {
            return;
        }
        expandToggleHandler();
    };
    expandButton.addEventListener('click', expandToggleHandler);
    expandButton.addEventListener('keyup', expandToggleKeyupHandler);
    // add expand button content
    outerLi.appendChild(expandButton);
    return [outerLi, groupLiWrapper];
};
const processMenuItem = (link) => {
    const outerLi = document.createElement('li');
    outerLi.dataset.testid = `mas-AppMenuListExpandableItem::${sanitizeToIdString(link.name)}`;
    outerLi.dataset.testName = 'mas-AppSwitcherMenuButton';
    outerLi.classList.add('mas-app-menu-list-item');
    if (link.highlighted) {
        outerLi.classList.add('highlighted');
    }
    const appIcon = getApplicationMenuLogoByApplicationType(link.icon);
    const appIconWrapper = document.createElement('div');
    if (appIcon) {
        appIconWrapper.classList.add('mas-application-type-logo-wrap');
        appIconWrapper.innerHTML = appIcon;
        outerLi.appendChild(appIconWrapper);
    }
    const menuItemWrapper = document.createElement('div');
    menuItemWrapper.classList.add('mas-application-type-list-item-button');
    const appAnchor = document.createElement('a');
    appAnchor.classList.add('mas-static-link-anchor');
    appAnchor.setAttribute('href', link.url);
    appAnchor.textContent = link.name;
    menuItemWrapper.appendChild(appAnchor);
    outerLi.appendChild(menuItemWrapper);
    return outerLi;
};
export const getApplicationMenuUi = (data, headerText) => {
    const isMenuData = (data) => 'applicationTypes' in data;
    const menuUl = document.createElement('ul');
    menuUl.dataset.testid = 'mas-AppMenuList';
    menuUl.classList.add('mas-app-menu-list');
    // header with medallia Logo
    menuUl.appendChild(getMenuHeaderLi(headerText));
    let menuItemGroups;
    if (isMenuData(data)) {
        const { applicationTypes: { nodes = [] } } = data;
        // Process nodes (normal applications)
        menuItemGroups = convertNodesToGroups(nodes);
    }
    else {
        menuItemGroups = data;
    }
    menuItemGroups.forEach((menuItem) => {
        const menuItemAsGroup = menuItem;
        if (menuItemAsGroup.groupName !== undefined) {
            const [outerLi, groupLiWrapper] = processExpandableMenuItems(menuItemAsGroup);
            menuUl.appendChild(outerLi);
            menuUl.appendChild(groupLiWrapper);
            return;
        }
        const menuItemAsLink = menuItem;
        const outerLi = processMenuItem(menuItemAsLink);
        menuUl.appendChild(outerLi);
    });
    return menuUl;
};
